import VideoViewer from './viewers/LmfrBrightCoveViewer';

export function init() {
  if (
    window &&
    window.Piivo &&
    window.Piivo.dam &&
    window.Piivo.dam.viewers &&
    window.Piivo.dam.viewers.registerViewer
  ) {
    window.Piivo.dam.viewers.registerViewer('mp4', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('avi', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('mov', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('m4v', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('wmv', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('asf', VideoViewer);
    window.Piivo.dam.viewers.registerViewer('flv', VideoViewer);
  }
}

init();
